import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import StoreDomainVariationMapping from "./StoreDomainVariationMapping";
import Image from "../image/Image";
import JsonMappedModel from "../helpers/JsonMappedModel";
import ProductVariationOptionCollection from "./ProductVariationOptionCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class ProductVariation extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [ProductVariation.id_attribute_name]: null,
      [ProductVariation.image_attribute_name]: Image,
      [ProductVariation.options_attribute_name]: ProductVariationOptionCollection,
      [ProductVariation.sku_attribute_name]: null,
      [ProductVariation.status_attribute_name]: ProductVariation.INACTIVE_STATUS,
      [ProductVariation.wc_product_variation_mapping_attribute_name]: StoreDomainVariationMapping
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getSkuAttributeName() {
    return this.sku_attribute_name;
  }
  static getImageAttributeName() {
    return this.image_attribute_name;
  }
  static getOptionsAttributeName() {
    return this.options_attribute_name;
  }
  static getStatusAttributeName() {
    return this.status_attribute_name;
  }
  getId() {
    return this.getAttribute(ProductVariation.id_attribute_name);
  }
  getOptions() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(ProductVariation.options_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getImage() {
    return this.getAttribute(ProductVariation.image_attribute_name);
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getSku() {
    return this.getAttribute(ProductVariation.sku_attribute_name);
  }
  getWcProductMapping() {
    return this.getAttribute(ProductVariation.wc_product_variation_mapping_attribute_name);
  }
  getWcProductMappingCustomId() {
    let wcVariationMapping = this.getWcProductMapping();
    return wcVariationMapping instanceof StoreDomainVariationMapping ? wcVariationMapping.getCustomVariationId() : null;
  }
}
_defineProperty(ProductVariation, "ACTIVE_STATUS", 'active');
_defineProperty(ProductVariation, "INACTIVE_STATUS", 'inactive');
_defineProperty(ProductVariation, "DELETED_STATUS", 'deleted');
_defineProperty(ProductVariation, "id_attribute_name", 'id');
_defineProperty(ProductVariation, "image_attribute_name", 'image');
_defineProperty(ProductVariation, "options_attribute_name", 'options');
_defineProperty(ProductVariation, "sku_attribute_name", 'sku');
_defineProperty(ProductVariation, "status_attribute_name", 'status');
_defineProperty(ProductVariation, "wc_product_variation_mapping_attribute_name", 'wc_product_variation_mapping');